import {Result} from "../result/index.js";
export class WPJson {
  constructor(json) {
    this.data = json;
  }
  static fromString(jsonString) {
    try {
      return Result.ok(new WPJson(JSON.parse(jsonString)));
    } catch (e) {
      return Result.error(e.message);
    }
  }
  getIf(keys) {
    const res = keys.reduce((acc, current) => {
      return acc[current] || null;
    }, this.data);
    if (res !== null) {
      return Result.ok(res);
    } else {
      return Result.error("not found");
    }
  }
  getOr(keys, or) {
    return keys.reduce((acc, current) => {
      return acc[current] || or;
    }, this.data);
  }
}
export class Category {
  constructor(slug, name) {
    this.slug = slug;
    this.name = name;
  }
  static fromWPJson(json) {
    const nodes = json.getOr(["nodes"], []);
    if (nodes.length > 0) {
      const node = new WPJson(nodes[0]);
      return Result.ok(new Category(node.getOr(["slug"], "unknown"), node.getOr(["name"], "\u4E0D\u660E")));
    }
    return Result.error("No categories have been set");
  }
}
export class Image {
  constructor(src, sizes) {
    this.src = src;
    this.sizes = sizes;
  }
  static fromWPJson(json) {
    const src = json.getIf(["sourceUrl"]);
    if (src.isError()) {
      return Result.error("sourceUrl not found");
    }
    const sizeList = json.getOr(["mediaDetails", "sizes"], []);
    let sizes = {};
    sizeList.forEach((s) => {
      sizes[s.name] = s.sourceUrl;
    });
    return Result.ok(new Image(src.unwrap(), sizes));
  }
  getSized(size) {
    return this.sizes[size] || this.src;
  }
}
export async function fetch(fetcher, url, query) {
  let res;
  try {
    res = await fetcher(url, {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({query})
    });
  } catch (error) {
    return Result.error(error.message);
  }
  if (!res.ok) {
    return Result.error(res.statusText, res.status);
  }
  try {
    const json = new WPJson(await res.json());
    const data = new WPJson(json.getIf(["data"]).unwrap());
    return Result.ok(data);
  } catch (error) {
    return Result.error(error.message);
  }
}
export async function fetchList(fetcher, url, query, key) {
  let res;
  try {
    res = await fetcher(url, {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({query})
    });
  } catch (error) {
    return Result.error(error.message);
  }
  if (!res.ok) {
    return Result.error(res.statusText, res.status);
  }
  try {
    const json = new WPJson(await res.json());
    const nodes = json.getOr(["data", key, "nodes"], []);
    return Result.ok(nodes.map((n) => new WPJson(n)));
  } catch (error) {
    return Result.error(error.message);
  }
}
//# sourceMappingURL=index.js.map
